module.exports = {
      id: "grey-check-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite-b16b2d73f82c96a320ba0490c6416430.svg#grey-check",
      toString: function () {
        return this.url;
      }
    }